<app-table>
    <ng-container header>
        <th class="index-column"></th>
        <th class="flex-1">
            <span>{{ 'NAME' | translate }}</span>
        </th>
        <th class="flex-2">
            <span>{{ 'ADDRESS' | translate }}</span>
        </th>
        <th class="flex-3 task-description">
            <span>{{ 'TASK_DESCRIPTION' | translate }}</span>
        </th>
        <th class="flex-1">
            <span>{{ 'ESTIMATED_VISIT' | translate }}</span>
        </th>
        <th class="flex-1">
            <span>{{ 'TRAVEL_TIME_TO_TASK' | translate }}</span>
        </th>
        @if (showFreeTimeBetweenTasksFeature | async) {
            <th class="flex-1">
                <span>{{ 'FREE_TIME_HEADER' | translate }}</span>
            </th>
        }
    </ng-container>
    <ng-container body>
        <div>
            @for (routeTask of routeTasks; track routeTask.taskId; let taskIndex = $index) {
                <div class="d-flex">
                    <div class="w-100">
                        <tr
                            cdkDrag
                            [cdkDragData]="routeTask"
                            class="w-100 d-flex"
                            [ngClass]="{'ride-sharing-table-row': routeTask.rideSharingConfig,
                                    'shift-split': routeTask.isShiftSplitTask,
                                    'colored': routeTask.color}"
                            [ngStyle]="{'border-color': routeTask.color }"
                            id="shift-split"
                        >
                            <td class="index-column">
                                <span> {{ taskIndex + 1 }} </span>
                            </td>
                            <td class="flex-1 task-name">
                                <span>{{ routeTask.name }}</span>
                            </td>
                            <td class="flex-2">
                                <span>{{ routeTask.address }}</span>
                            </td>
                            <td class="flex-3 task-description">
                                @if (!routeTask.rideSharingConfig) {
                                    <span>{{ routeTask.serviceName }}</span>
                                }
                                @if (routeTask.rideSharingConfig) {
                                    <span>
                                        {{ routeTask.serviceName | translate: {employeeName: getRideSharingCompanionsName(routeTask)} }}
                                     </span>
                                }
                            </td>
                            <td class="flex-1 task-row-time-window"
                                [ngClass]="{ 'cell-warning': routeTask.outsideTimeWindow && !showTaskDelayHighlight}">
                                <div class="d-inline-flex my-auto">
                                    <span>
                                    {{ routeTask | fromto }}
                                    </span>
                                    @if (showTaskDelayHighlight) {
                                        <span
                                            class="vismaicon vismaicon-sm ml-1 my-auto"
                                            [ngClass]="{
                                                'icon-warning-multicolor': routeTask.taskDelaySeverity === DelayLevel.ShortDelay,
                                                'icon-warning-multicolor-orange': routeTask.taskDelaySeverity === DelayLevel.MediumDelay,
                                                'icon-warning-multicolor-red': routeTask.taskDelaySeverity === DelayLevel.SevereDelay,
                                            }"
                                        ></span>
                                    }
                                </div>
                            </td>
                            <td class="flex-1">
                                <span class="mx-auto">
                                    {{ routeTask.travelTimeFromPrev }} min
                                </span>
                            </td>
                            <td class="flex-1">
                                @if (taskIndex !== 0) {
                                    <span class="mx-auto"
                                    >
                                        {{ routeTasks[taskIndex].freeTimeBeforeTask }} min
                                    </span>
                                }
                            </td>
                        </tr>
                    </div>
                </div>
            }
        </div>
    </ng-container>
</app-table>
